import { AgentGrounding } from '@d-id/types';

export const DEFAULT_AGENT_GROUNDING = AgentGrounding.Ungrounded;
